/**
 *
 */
import {Conf} from '../viewmodel/config.js';
import DataManager from './datamanager/index.js';
import Util, {deepCopy,curryThrottle,resizeObserver,curryDebounce} from '../util/index.js';
import {
  MAIN_AREA,
  FOOT_AREA,
  NET_STATUS,
  KEY_MAP,
  TREND_TYPE,
  TREND_ONE,
  TREND_FIVE,

  KLINE_ONEMIN,
  KLINE_FIVEMIN,
  KLINE_FIFMIN,
  KLINE_THIMIN,
  KLINE_SIXMIN,
  KLINE_ONEDAY,
  KLINE_ONEWEEK,
  KLINE_ONEMONTH,
  KLINE_ONEYEAR,
  KLINE_PRICE_TYPE
} from '../viewmodel/index.js';
import {
  checkMainBlackList,
  checkFootBlackList,
  isKline,
  beforeLog,
  afterLog,
  checkAmerican,
  transformTime,
} from './util';
import ChainMap from './datamanager/database/chainmap';
import Matrix2d from '../math/matrix2d/index.js';
const {
  TREND_KEY,
  MA_KEY,
  JZ_KEY,
  KD_KEY,
  BOLL_KEY,

  AMOUNT_KEY,
  MACD_KEY,
  KDJ_KEY,
  ENE_KEY,
  ELECTRIC_KEY,
  FUNDFLOW_KEY,
  FUNDFLOWDIR_KEY,
} = KEY_MAP;
const {LOADING, ERROR, LOADED} = NET_STATUS;
const {TREND_WD, TREND_MX, TREND_CJ} = TREND_TYPE;
/***  埋点Map ***/
const eventMap = {
  [TREND_WD]: 'hshq104_7五档',
  [TREND_MX]: 'hshq104_8明细',
  [TREND_CJ]: 'hshq104_9成交',
  [TREND_ONE]: 'hshq104_1分时',
  [TREND_FIVE]: 'hshq104_2五日',
  [KLINE_ONEMIN]: 'hshq104_6分钟K',
  [KLINE_FIVEMIN]: 'hshq104_6分钟K',
  [KLINE_FIFMIN]: 'hshq104_6分钟K',
  [KLINE_THIMIN]: 'hshq104_6分钟K',
  [KLINE_SIXMIN]: 'hshq104_6分钟K',
  [KLINE_ONEDAY]: 'hshq104_3日K',
  [KLINE_ONEWEEK]: 'hshq104_4周K',
  [KLINE_ONEMONTH]: 'hshq104_5月K',
  [KLINE_ONEYEAR]: 'hshq104_10年k'
};
const trendFootMap = {
  [AMOUNT_KEY]: 'hshq104_10成交量',
  [MACD_KEY]: 'hshq104_12MACD',
  [FUNDFLOW_KEY]: 'hshq104_11资金博弈',
  [FUNDFLOWDIR_KEY]: 'hshq104_11资金流向'
};
const klineFootMap = {
  [AMOUNT_KEY]: 'hshq104_13成交量-K',
  [MACD_KEY]: 'hshq104_14MACD-K',
  [KDJ_KEY]: 'hshq104_15KDJ',
  [ENE_KEY]: 'hshq104_16ENE',
  [ELECTRIC_KEY]: 'hshq104_17晓鲸电波',
};
const klineMainMap = {
  [MA_KEY]: 'hshq107_1均线',
  [JZ_KEY]: 'hshq107_2鲸奇9转',
  [KD_KEY]: 'hshq107_3KD密码',
  [BOLL_KEY]: 'hshq107_4BOLL'
};
export default class Controller {
  constructor(props) {
    this.isRendering = false;
    this.subs = new Map();
    this.queueKey = new Set(); // key set去重
    this.queue = new Set(); // 包含context和args
    this.store = new DataManager(props);
    this.timer = null;
    this.positionObserve = null;
    [
      '_queueUpdate',
      '_render',
      'commit',
      'dispatch',
      'drawGraph',
      'drawTimer',
      'setStartAndEnd',
      'setCurrent',
      'setScreenDirection',
      'changeMainState',
      'changeFootState',
      'watch',
      'destroy'
    ].forEach(method => {
      this[method] = this[method].bind(this);
    });
    return {
      state: this.store.state,
      watch: this.watch,
      commit: this.commit,
      dispatch: this.dispatch
    }
  }
  _queueUpdate(subKey) {
    const subMap = this.subs.get(subKey);
    for (let [key, value] of subMap) {
      if (!this.queueKey.has(key)) {
        const {context, args, expression} = value;
        // 表达式判断是否需要加入更新队列
        if (Util.isFunction(expression)) {
          const isUpdate = expression();
          if (!isUpdate) {
            return;
          }
        }
        if (context) {
          this.queue.add(function() {
            key.apply(context, args);
          })
        } else {
          this.queue.add(function() {
            key(args);
          })
        }
        this.queueKey.add(key);
      }
    }
    if (!this.isRendering) {
      this.isRendering = true;
      setTimeout(this._render, 0);
    }
  }
  _render() {
    // console.time('render');
    this.queue.forEach(fn => {
      fn();
    });
    this.queueKey.clear();
    this.queue.clear();
    this.isRendering = false;
    // console.timeEnd('render');
  }
  commit(method, payload) {
    if (Util.isArray(payload)) {
      this[method].apply(this, payload);
    } else {
      this[method].call(this, payload);
    }
  }
  async dispatch(method, payload) {
    if (Util.isArray(payload)) {
      await this[method].apply(this, payload);
    } else {
      await this[method].call(this, payload);
    }
  }
  mousemove(e) {
    const {clientX,clientY,pageX, pageY} = e
    this.store.state.pageX = pageX
    this.store.state.pageY = pageY
    this.store.state.clientX = clientX
    this.store.state.clientY = clientY
  }
  mouseleave(e) {
    const {pageX} = e
    this.store.state.pageX = pageX
  }
  /**
   * 放大缩小显示条目数量
   * end不动，移动start
   */
  narrow() {
    const { state} = this.store;
    let {start, end, maxLen, len, stepLen, min_time} = state;
    const {code,period}=state
    // this.state.data.kline的数据
    const nowLen = end - start;
    const isAmerican = checkAmerican(code);
    // const type = period==KLINE_ONEYEAR||len<200?nowLen < maxLen:start>stepLen
    const type = end<200?nowLen < maxLen:start>=stepLen
    // console.log(end<200,type,'min_time.length')
    // if (nowLen <= maxLen) {
      if (type) {
      const newLen = nowLen + stepLen;
      start = Math.max(0, start - stepLen);
      end = start + newLen;
      // end = len;???
      this.store.state.start = start;
      this.store.state.end = end;
      const current = Math.max(Math.min(end - 1, len - 1), 0);
      this.store.state.current = current;
      this.store.state.axisX = [
        transformTime({timeStamp: min_time[start], code, isAmerican}),
        transformTime({timeStamp: min_time[current], code, isAmerican})
      ];
      // this.store.state.axisX = [min_time[start], min_time[current]];
    }
    if(start<=stepLen&&len>maxLen){
      this.positionObserve = curryThrottle(this.narrowMore(), this, 500);//节流
    }
  }
  async narrowMore(){
    const { state,getMore} = this.store;
    let {start, min_time,moreDataStep,stepLen} = state;
    const {code,period}=state
    let param={
      // end_date:state.min_time[1],
      search_direction:1,
      date:period==KLINE_ONEDAY?min_time[1]:min_time[0],
      data_count: moreDataStep
    }
    //开始请求数据
    getMore(code, period, param).then(async (v) => {
      let {code: newCode, period: newPeriod} = state;
      if (code !== newCode || period !== newPeriod) {
        return;
      }
      const { footChain, mainChain } = state;
      const mainRst = mainChain.get();
      const footRst = footChain.get()
      await Promise.all([
        mainRst && this.store.getMainData(mainRst.key),
        footRst && this.store.getFootData(footRst.key),
      ]);
      const len = this.store.state.end+v
      this.store.state.start=start+v
      this.store.state.end=len
      const current = Math.max(Math.min(len - 1, len - 1), 0);
      this.store.state.current = current;
      const isAmerican = checkAmerican(code);
      this.store.state.axisX = [
        transformTime({timeStamp: min_time[start], code, isAmerican}),
        transformTime({timeStamp: min_time[current], code, isAmerican})
      ];
      this.store.state.status = LOADED;
    }).catch(err => {
      console.warn(err)
      const {code: newCode, period: newPeriod} = this.store.state;
      if (period === newPeriod && code === newCode) {
        this.store.state.status = ERROR;
      }
    });
  }
  enlarge() {
    let {start, end, minLen, len, stepLen, min_time, code} = this.store.state;
    const nowLen = end - start;
    const isAmerican = checkAmerican(code);
    if (nowLen > minLen) {
      const skewLen = end - len;
      const newLen = nowLen - stepLen;
      start += stepLen;
      // end大于len时，K线图右边有多余空白，则整体向右偏移
      if (skewLen > 0) {
        start = Math.max(0, start - skewLen);
        end = start + newLen;
      }
      this.store.state.start = start;
      this.store.state.end = end;
      const current = Math.max(Math.min(end - 1, len - 1), 0);
      this.store.state.current = current;
      this.store.state.axisX = [
        transformTime({timeStamp: min_time[start], code, isAmerican}),
        transformTime({timeStamp: min_time[current], code, isAmerican})
      ];
      // this.store.state.axisX = [min_time[start], min_time[current]];
    }
  }
  setStartAndEnd({start, end}) {
    // 仅K线支持左右滑动
    const {min_time, code} = this.store.state;
    const isAmerican = checkAmerican(code);
    this.store.state.start = start;
    this.store.state.end = end;
    this.store.state.current = Math.max(0, end - 1);
    this.store.state.axisX = [
      transformTime({timeStamp: min_time[start], code, isAmerican}),
      transformTime({timeStamp: min_time[end - 1], code, isAmerican})
    ];
    // this.store.state.axisX = [min_time[start], min_time[end - 1]];
  }
  setCurrent({current}) {
    const {start, end} = this.store.state;
    if (Util.isValidNumber(current) && start <= current && current < end) {
      this.store.state.current = current;
    }
  }
  setPress(isPress) {
    if (Util.isBoolean(isPress)) {
      this.store.state.isPress = isPress;
    }
  }
  setGraphStatus(status) {
    this.store.state.isFullScreen = status;
  }
  setScreenDirection(isVertical) {
    this.store.state.isVertical = isVertical;
  }
  setThrottle(throttle) {
    Util.isValidNumber(throttle) && (this.store.state.throttle = throttle);
  }
  /**
   * 设置元素变换矩阵
   */
  setEleMatrix({matrix, transformOrigin}) {
    const transitionMatrix = Matrix2d.calcInverseMatrix(matrix);
    this.store.state.transitionMatrix = transitionMatrix;
    this.store.state.transformOrigin = transformOrigin;
  }
  /**
   *
   */
  setElePosition({position}) {
    if (Util.isArray(position) && position.every(a => Util.isValidNumber(a))) {
      this.store.state.position = position;
    }
  }
  /**
   *
   */
  setBaseSize(baseSize) {
    if (Util.isValidNumber(baseSize)) {
      this.store.state.baseSize = baseSize;
    }
  }
  setActivate(isActive) {
    if (Util.isBoolean(isActive)) {
      this.store.state.isActive = isActive;
    }
  }
  setFundFlowStatus(status) {
    // 设置是否显示分时成交
    if (Util.isBoolean(status)) {
      this.store.state.isShowFundflow = status;
    }
  }
  setGraphConfig(config) {
    if (Util.isObject(config)) {
      this.store.state.graphConfig = config;
    }
  }
  setLog(log) {
    if (Util.isBoolean(status) && !status) {
      this.store.state.log = null;
    } else {
      this.store.state.log = log;
    }
  }

  // 初始化时设置modules列表
  setMainModules({modules, auths}) {
    const hasJZAuth = auths & JZ_KEY && modules & JZ_KEY;
    const {MAIN_STATUS} = this.store.state;
    for (let val of Object.values(MAIN_STATUS)) {
      val.forEach(item => {
        item.forbidden = !(item.key & modules);
        item.noauth = !(item.key & auths);
        // 开通9转组件，且用户有9转权限的，默认显示9转
        if (hasJZAuth && item.key === JZ_KEY) {
          item.default = true;
        }
      })
    }
    this.reDrawGraph();
  }
  setFootModules({modules, auths}) {
    const {FOOT_STATUS} = this.store.state;
    for (let val of Object.values(FOOT_STATUS)) {
      val.forEach(item => {
        item.forbidden = !(item.key & modules);
        item.noauth = !(item.key & auths);
        if (item.key === ELECTRIC_KEY && !item.noauth) {
          item.default = true;
        }
      })
    }
    this.reDrawGraph();
  }
  // 修改特定的辅视图模块权限
  setFootModuleAuth({key, noAuth = true}) {
    const {FOOT_STATUS} = this.store.state;
    for (let val of Object.values(FOOT_STATUS)) {
      const item = val.find(a => a.key === key);
      if (item) {
        item.noauth = !!noAuth;
      }
    }
  }

  /**
   * 根据code和period
   * 过滤掉无效的status
   */
  getValidMainStatus(code, period) {
    const {MAIN_STATUS} = this.store.state;
    const {hqTypeCode, tradeStatus} = this.store.state.sealObj;
    const blackList = checkMainBlackList({code, period, hqTypeCode, tradeStatus});
    return MAIN_STATUS[period].filter(a => !a.forbidden && !blackList.find(b => b === a.key));
  }
  getValidFootStatus(code, period) {
    const {FOOT_STATUS} = this.store.state;
    const {hqTypeCode, tradeStatus} = this.store.state.sealObj;
    const blackList = checkFootBlackList({code, period, hqTypeCode, tradeStatus});
    return FOOT_STATUS[period].filter(a => !a.forbidden && !blackList.find(b => b === a.key));
  }
  //外汇中间操作
  async getForeignCode(code,period,type){
    const { getForeignInfo } = this.store;
    getForeignInfo(code, period,type).then(async (dealCode) => {
      this.drawGraph(dealCode,period,{},{ business_type:type })
    }).catch(err => {
      console.warn(err)
      const {code: newCode, period: newPeriod} = this.store.state;
      if (period === newPeriod && code === newCode) {
        this.store.state.status = ERROR;
      }
    });
  }
  // 切换period或code调用
  /**
   * 点击分时，五日，日K等事件埋点
   */
  async drawGraph(code, period, option = {},params) {
    const {state, getData, getSealData} = this.store;
    const {code: oldCode, period: oldPeriod} = this.store.state;
    code = code || oldCode;
    period = period || oldPeriod;
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;

    }
    // 无code或无period时，不请求数据
    // 防止出现暂无数据
    if (!code || !period||code==0) {
      return;
    }
    this.store.state.status = LOADING;
    if (code !== oldCode && code) {
      await getSealData(code);
    }
    /*** 缓存之前的视图key ***/
    let mainKey, footKey;
    let {footChain, mainChain} = state;
    if (footChain) {
      const foot = footChain.get();
      foot && (footKey = foot.key);
    }
    if (mainChain) {
      const main = mainChain.get();
      main && (mainKey = main.key);
    }
    /*** 根据code,period,hqTypeCode获取有效视图列表 ***/
    const mainStatus = this.getValidMainStatus(code, period);
    const footStatus = this.getValidFootStatus(code, period);
    this.store.state.footChain = footChain = new ChainMap(footStatus);
    this.store.state.mainChain = mainChain = new ChainMap(mainStatus);

    getData(code, period, option,params).then(async () => {
      let {code: newCode, period: newPeriod} = state;
      if (code !== newCode || period !== newPeriod) {
        return;
      }
      const getKey = (chain, key, isReserve) => {
        let item = (isReserve && key && chain.move(a => a.key === key && !a.noauth)) || chain.get();
        if (!item) {
          return null
        }
        if (item.noauth) {
          item = chain.move(a => !a.noauth);
        }
        return item.key;
      };
      mainKey = getKey(mainChain, mainKey);
      footKey = getKey(footChain, footKey,true);

      // 显示默认视图
      await Promise.all([
        this.changeMainState(mainKey),
        this.changeFootState(footKey)
      ]);
      /*
      status修改放到最后，以全量更新主辅视图
       */
      this.store.state.status = LOADED;

      // 定时刷新数据
      const {isAutoRefresh, throttle} = state;
      if (isAutoRefresh && throttle) {
        this.timer = setInterval(this.drawTimer, 10000);
      }
    }).catch(err => {
      console.warn(err)
      const {code: newCode, period: newPeriod} = this.store.state;
      if (period === newPeriod && code === newCode) {
        this.store.state.status = ERROR;
      }
    });
  }
  // 权限修改重绘
  async reDrawGraph() {
    const key = this.reDrawGraph;
    if (!this.subs.has(key)) {
      const sub = new Map();
      sub.set(this.drawGraph, {
        expression: () => (this.store.state.status !== LOADING),
      });
      this.subs.set(key, sub);
    }
    this._queueUpdate(key);
  }

  // 用作分时定时请求后端获取数据
  async drawTimer() {
    if(!this.store) {
      clearInterval(this.timer)
      return
    }
    const {state, getData,getForeignInfo} = this.store;
    const {code, period, isAutoRefresh, footChain, mainChain,business_type} = state;
    if (!isAutoRefresh) return;
    const mainRst = mainChain.get();
    const footRst = footChain.get()
    getData(code, period, {isAppend: true,isRestPosition:false},{business_type:business_type}).then(async () => {
      await Promise.all([
        mainRst && this.store.getMainData(mainRst.key),
        footRst && this.store.getFootData(footRst.key),
      ]);
      this.store.state.status = LOADED;
    }).catch(err => {
      console.warn(err);
      const {code: newCode, period: newPeriod} = state;
      if (period === newPeriod && code === newCode) {
        this.store.state.status = ERROR;
      }
    });
  }
  // 切换主视图
  /**
   * 点击K线页面策略下拉选项埋点
   */
  async changeMainState(key) {
    const {mainChain,business_type} = this.store.state;
    let rst;
    if (!Util.isUndefined(key)) {
      rst = mainChain.move(a => a.key === key);
    } else {
      rst = mainChain.next();
    }
    if (rst) {
      const { END_PRICE,CENTER_PRICE } = KLINE_PRICE_TYPE
      const {key, context} = rst;
      await this.store.getMainData(key);
      if(business_type == END_PRICE || business_type == CENTER_PRICE){
        this.store.state.kLineMapKey = 12; // 在外汇的收盘价和中间价的情况下默认为折线形
      }else {
        this.store.state.kLineMapKey = 0; // 默认为普通k线
      }
      this.store.state.mainContextKey = key;
    } else {
      this.store.state.kLineMapKey = key
    }
  }
  // 切换辅视图
  /**
   * 点击K线成交量、MACD、KDJ、ENE、晓鲸电波埋点
   */
  /**
   * 点击分时成交量、资金博弈、MACD埋点
   */
  async changeFootState(key) {
    const {footChain} = this.store.state;
    let rst;
    if (!Util.isUndefined(key)) {
      rst = footChain.move(a => a.key === key);
    } else {
      rst = footChain.next();
    }
    if (rst) {
      const {key, context} = rst;
      await this.store.getFootData(key);
      this.store.state.footContextKey = key;
    }
  }
  async changeSide(status) {
    await this.store.getDetailData(status);
  }
  // 切换除复权，不重置start和end
  async changeKlineStatus(status) {
    this.store.getKlineRightData(status);
    const {code, period} = this.store.state;
    await this.drawGraph(code, period, {isRestPosition: false});
  }

  //TODO 只监听浅对象
  watch({target, key: keys, fn, context, args, expression}) {
    target = target || this.store.state;
    const _watch = key => {
      if (this.subs.has(key)) {
        const subscribeList = this.subs.get(key);
        if (!subscribeList.has(fn)) {
          subscribeList.set(fn, {context, args});
        }
      } else {
        const sub = new Map();
        sub.set(fn, {context, args, expression});
        this.subs.set(key, sub);
        const that = this;
        const property = Object.getOwnPropertyDescriptor(target, key);
        const getter = property && property.get;
        const setter = property && property.set;
        let val = target[key];
        Object.defineProperty(target, key, {
          get: function() {
            const value = getter ? getter.call(target) : val;
            return value;
          },
          set: function(newVal) {
            const value = getter ? getter.call(target) : val;
            if (newVal === value) {
              return;
            }
            if (setter) {
              setter.call(target, newVal);
            } else {
              val = newVal;
            }
            that._queueUpdate(key);
          }
        })
      }
    }
    if (Util.isArray(keys)) {
      for (let key of keys) {
        _watch(key);
      }
    } else {
      _watch(keys);
    }
  }
  destroy() {
    const {footChain, mainChain} = this.store.state;
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if(this.positionObserve){
      // this.positionObserve.unobserve(document.body);
      this.positionObserve = null;
    }
    footChain && footChain.clear();
    mainChain && mainChain.clear();
    this.subs.clear();
    this.queue.clear();
    this.queueKey.clear();
    this.store.state = null;
    this.store = null;
  }
}
